// extracted by mini-css-extract-plugin
export default {"RecoverPasswordPage":"RecoverPasswordPage_RecoverPasswordPage__kRe92"};